import {Component, HostListener, ViewChild, ViewContainerRef, ComponentRef, OnInit, AfterViewInit} from '@angular/core';
import { CreateOrganizationComponent } from '../../../pages/organization/organization-create/organization-create.component';
import { PatientCreateComponent } from '../../../pages/definition/patient/patient-create/patient-create.component';
import { MedicalAdviceComponent } from '../medical-advice/medical-advice.component';
import { CreatePriceInfoComponent } from '../../../pages/price-info/create/create-price-info.component';
import { WorklistCreateComponent } from '../../../pages/worklist/worklist-create/worklist-create.component';
import { ShortcutService } from './service/shortcut.service';
import {ActivatedRoute, Router} from '@angular/router';
import { CreateCaseSummaryComponent } from '../create-case-summary/create-case-summary.component';

@Component({
  selector: 'app-shortcut',
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss']
})
export class ShortcutComponent implements OnInit, AfterViewInit {
  isToggleOpen = false;

  @ViewChild('orgCreate', { read: ViewContainerRef }) orgCreate!: ViewContainerRef;
  @ViewChild('patientCreate', { read: ViewContainerRef }) patientCreate!: ViewContainerRef;
  @ViewChild('medicalAdviceDialog', { read: ViewContainerRef }) medicalAdviceDialog!: ViewContainerRef;
  @ViewChild('priceInfoCreate', { read: ViewContainerRef }) priceInfoCreate!: ViewContainerRef;
  @ViewChild('workCreate', { read: ViewContainerRef }) workCreate!: ViewContainerRef;
  @ViewChild('caseCreate', { read: ViewContainerRef }) caseCreate!: ViewContainerRef;

  private orgComponentRef!: ComponentRef<CreateOrganizationComponent>;
  private patientComponentRef!: ComponentRef<PatientCreateComponent>;
  private medicalComponentRef!: ComponentRef<MedicalAdviceComponent>;
  private priceComponentRef!: ComponentRef<CreatePriceInfoComponent>;
  private workComponentRef!: ComponentRef<WorklistCreateComponent>;
  private caseSummaryRef!: ComponentRef<CreateCaseSummaryComponent>;

  constructor(private readonly shortcutService: ShortcutService,
     private readonly router: Router,
              private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.shortcutService.trigger$.subscribe(() => {
      this.isToggleOpen = !this.isToggleOpen;
    });

  }

  toggleMenu() {
    this.isToggleOpen = !this.isToggleOpen;
  }

  createOrganization() {
    if (!this.orgComponentRef) {
      this.orgComponentRef = this.orgCreate.createComponent(CreateOrganizationComponent);
    }
    this.orgComponentRef.instance.openCanvas(null);
  }

  createPatient() {
    if (!this.patientComponentRef) {
      this.patientComponentRef = this.patientCreate.createComponent(PatientCreateComponent);
    }
    this.patientComponentRef.instance.openOffcanvas();
  }

  createMedicalAdviceDialog() {
    if (!this.medicalComponentRef) {
      this.medicalComponentRef = this.medicalAdviceDialog.createComponent(MedicalAdviceComponent);
    }
    this.medicalComponentRef.instance.openDialog();
  }

  createPriceInfo() {
    if (!this.priceComponentRef) {
      this.priceComponentRef = this.priceInfoCreate.createComponent(CreatePriceInfoComponent);
    }
    this.priceComponentRef.instance.openOffCanvas();
  }

  createWork() {
    if (!this.workComponentRef) {
      this.workComponentRef = this.workCreate.createComponent(WorklistCreateComponent);
    }
    this.workComponentRef.instance.visible = true;
  }

  openCaseSummary(){
    this.openNewLink('/dashboard',{caseSummary: true});
   /* if(!this.caseSummaryRef){
      this.caseSummaryRef = this.caseCreate.createComponent(CreateCaseSummaryComponent)
    }
    this.caseSummaryRef.instance.isVisible = true;
    this.caseSummaryRef.instance.open();*/
  }

  openFile() {
  /*  const urlTree = this.router.createUrlTree(['/file-case']);

    const url = this.router.serializeUrl(urlTree);

    window.open(url, '_blank');*/
    this.openNewLink('/file-case',null);
  }

  openLink(type: 'case' | 'appointment' | 'watch', options?: any) {
    switch (type) {
      case 'case':
        this.openNewLink('/case', {
        case: true
      });
     /*   window.open(this.router.createUrlTree(['/case'], { queryParams: { fullscreen: true, case: true } }).toString(), '_blank');*/
        break;
      case 'appointment':
         this.openNewLink('/case', {
        appointment: true
      });
       /* window.open(this.router.createUrlTree(['/case'], { queryParams: { fullscreen: true, appointment: true } }).toString(), '_blank');*/
        break;
      case 'watch':
        this.openNewLink('/watch-popup/lists',null);
      /*  window.open('/watch/lists', '_blank');*/
        break;
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'F2') {
      event.preventDefault();
      this.toggleMenu();
    }
  }



  async openNewLink(path: string, parameter?: any) {
    const width = 1400;
    const height = 900;

    const urlTree = this.router.createUrlTree(
      [path],
      parameter
        ? {
          queryParams: {
            ...parameter,
          },
        }
        : undefined
    );

    const url = this.router.serializeUrl(urlTree);

    const features = [
      `width=${width}`,
      `height=${height}`,
      'resizable=yes',
      'scrollbars=yes',
      'status=yes',
      'toolbar=no',
      'menubar=no',
      'location=no',
    ].join(',');

    const popup = window.open(url, '_blank', features);

    if (popup) {
      popup.focus();
    }
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['caseSummary']) {
        if(!this.caseSummaryRef){
          this.caseSummaryRef = this.caseCreate.createComponent(CreateCaseSummaryComponent)
        }
        this.caseSummaryRef.instance.isVisible = true;
        this.caseSummaryRef.instance.open();
      }
    });
  }
}
